import { getMutationHandler } from '@frontend/duck-tape';
import { showToast } from '@frontend/web-react';
import { addSentryBreadcrumb } from '@frontend/web-utils';

export const handleMutation = getMutationHandler({ addSentryBreadcrumb, showToast });
